import { fulfilled } from "lib/promiseMiddlewareTypes";
import initialState from "store/initialState";
import keyBy from "lodash/keyBy";
import {
  ADD_SUBJECT_DETAILS_FOR_PREVIEW,
  GET_SUBJECT_BY_CODE,
  GET_SUBJECT_BY_CODE_FOR_PREVIEW,
  GET_SUBJECT_DETAILS,
} from "actions/subjectDetails";
import { EXECUTE_SUBJECT_QUERY } from "actions/subjectQueryResult";

const subjectDetails = (state = initialState.subjectDetails, action: any) => {
  switch (action.type) {
    case ADD_SUBJECT_DETAILS_FOR_PREVIEW:
      return {
        ...state,
        ...keyBy(
          action.payload?.filter((e: any) => e && e.recordId),
          (e) => e.recordId,
        ),
      };
    case fulfilled(GET_SUBJECT_DETAILS):
    case fulfilled(GET_SUBJECT_BY_CODE):
      return {
        ...state,
        ...keyBy(
          action.payload?.filter((e: any) => e && e.recordId),
          (e) => e.recordId,
        ),
      };
    // give preference to subjects in Draft/Approval/Configuration over published
    case fulfilled(GET_SUBJECT_BY_CODE_FOR_PREVIEW):
      return {
        ...state,
        ...keyBy(
          [...(action.payload || [])]
            .filter((e: any) => e && e.recordId)
            .sort((a, b) => {
              // Published should come first
              if (a.state === "Published" && b.state !== "Published") return -1;
              if (a.state !== "Published" && b.state === "Published") return 1;
              // Compare only the suffix in versionId as the year will be the same
              const aSuffix = Number(a.version.split(".")[1]);
              const bSuffix = Number(b.version.split(".")[1]);
              return aSuffix - bSuffix;
            }),
          (e) => e.recordId,
        ),
      };
    case fulfilled(EXECUTE_SUBJECT_QUERY):
      return {
        ...state,
        ...keyBy(
          action.payload?.result?.filter((e: any) => e && e.recordId),
          (e) => e.recordId,
        ),
      };
    default:
      return state;
  }
};

export default subjectDetails;
